import PasswordFindCode from '../../../../components/Auth/PasswordFindCode';
import '../FindAuthForm.css';
import '../find.css';

const FindCodePage = () => {
    return (
        <div className="findPage">
            <PasswordFindCode />
        </div>
    );
};

export default FindCodePage;
